// extracted by mini-css-extract-plugin
export default {"msgM":"_1658ae035f"};